export const wordBreakValue = (countryCode) => {
  return countryCode === 'KR' ? 'keep-all' : 'break-word';
};
